import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "mb-4" };
const _hoisted_2 = { class: "form-floating mb-3" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col d-flex align-items-center justify-content-center mb-3" };
const _hoisted_5 = { class: "text-center" };
const _hoisted_6 = {
    key: 0,
    class: "bg-success text-white px-3 py-2 text-center"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["onClick"];
import { router, useForm } from '@inertiajs/vue3';
import { onMounted, ref } from 'vue';
import { responseMessages } from '@/Composables/responseMessages';
import { useConfirm } from 'primevue';
import axios from 'axios';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductImages',
    props: {
        bottle: Object,
        lid: Object,
        package: Object,
        accessoryProduct: Object,
        //TODO: other relation types
    },
    setup(__props) {
        let { showPageFlashMessage, showErrorMessage } = responseMessages();
        const props = __props;
        const confirm = useConfirm();
        const imageUploadForm = useForm({
            imageFile: null
        });
        const relationType = ref(null);
        const relationUuid = ref(null);
        const productImages = ref([]);
        onMounted(() => {
            if (props.bottle) {
                relationType.value = 'bottles';
                relationUuid.value = props.bottle.uuid;
            }
            if (props.lid) {
                relationType.value = 'lids';
                relationUuid.value = props.lid.uuid;
            }
            if (props.package) {
                relationType.value = 'packages';
                relationUuid.value = props.package.uuid;
            }
            if (props.accessoryProduct) {
                relationType.value = 'accessoryProducts';
                relationUuid.value = props.accessoryProduct.uuid;
            }
            //TODO: other relation types
            loadImages();
        });
        function loadImages() {
            if (relationUuid.value == null) {
                return;
            }
            axios.post(route('admin.' + relationType.value + '.productImages.index', relationUuid.value), {})
                .then(function (response) {
                productImages.value = response.data;
            })
                .catch(function (error) {
                console.log(error);
                productImages.value = [];
            });
        }
        function upload() {
            if (relationUuid.value == null) {
                return;
            }
            imageUploadForm.transform((data) => ({
                image_file: data.imageFile
            }))
                .submit('post', route('admin.' + relationType.value + '.productImages.store', relationUuid.value), {
                preserveScroll: true,
                onSuccess: page => {
                    imageUploadForm.reset();
                    loadImages();
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function setMain(image) {
            router.put(route('admin.productImages.setMain', image.uuid), {}, {
                preserveScroll: true,
                onSuccess: page => {
                    productImages.value.map((item) => {
                        if (item.uuid === image.uuid) {
                            item.isMain = true;
                        }
                        else {
                            item.isMain = false;
                        }
                        return item;
                    });
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function remove(image) {
            confirm.require({
                message: 'Soll das Produkt-Bild wirklich gelöscht werden?',
                header: 'Produkt-Bild löschen?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    router.delete(route('admin.productImages.destroy', image.uuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            productImages.value = productImages.value.filter((item) => item.uuid !== image.uuid);
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("form", {
                        onSubmit: _withModifiers(upload, ["prevent"]),
                        enctype: "multipart/form-data"
                    }, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("input", {
                                type: "file",
                                onInput: _cache[0] || (_cache[0] = ($event) => (_unref(imageUploadForm).imageFile = $event.target.files[0])),
                                class: "form-control",
                                id: "newProductImage"
                            }, null, 32),
                            _cache[1] || (_cache[1] = _createElementVNode("label", { for: "newProductImage" }, "Neues Produkt-Bild", -1))
                        ]),
                        _cache[2] || (_cache[2] = _createStaticVNode("<button type=\"submit\" class=\"btn btn-success d-inline-flex align-items-center\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" fill=\"currentColor\" class=\"bi bi-cloud-upload\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383\"></path><path fill-rule=\"evenodd\" d=\"M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708z\"></path></svg><span class=\"ms-2\">Upload</span></button>", 1))
                    ], 32)
                ]),
                _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productImages.value, (image) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", {
                                    class: _normalizeClass([{ 'border border-success rounded': image.isMain }, "mb-3"])
                                }, [
                                    (image.isMain)
                                        ? (_openBlock(), _createElementBlock("h5", _hoisted_6, "Hauptbild"))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("img", {
                                        src: image.url,
                                        style: { "height": "350px", "max-width": "100%" },
                                        class: "m-3"
                                    }, null, 8, _hoisted_7)
                                ], 2),
                                (!image.isMain)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "btn btn-success",
                                        onClick: ($event) => (setMain(image))
                                    }, "Als Hauptbild", 8, _hoisted_8))
                                    : _createCommentVNode("", true),
                                _createElementVNode("button", {
                                    class: "btn",
                                    onClick: ($event) => (remove(image))
                                }, [...(_cache[3] || (_cache[3] = [
                                        _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            height: "40",
                                            fill: "currentColor",
                                            class: "bi bi-x-circle-fill text-danger",
                                            viewBox: "0 0 16 16"
                                        }, [
                                            _createElementVNode("path", { d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" })
                                        ], -1)
                                    ]))], 8, _hoisted_9)
                            ])
                        ]));
                    }), 256))
                ])
            ], 64));
        };
    }
});
